const Aircrafts = {
  10: [
    'Hurricane I',
    'Hurricane I',
    'Hurricane I',
    'Hurricane I',
    'Hurricane I',
    'Hurricane I',
    'Spitfire I/IIA',
    'Spitfire I/IIA',
    'Spitfire I/IIA',
    'Spitfire I/IIA',
    'Spitfire I/IIA',
  ],
  11: [
    'Blenheim Mk I',
    'Blenheim Mk I',
    'Defiant',
    'Hurricane I',
    'Hurricane I',
    'Hurricane I',
    'Hurricane I',
    'Hurricane I',
    'Spitfire I/IIA',
    'Spitfire I/IIA',
    'Spitfire I/IIA',
  ],
  12: [
    'Blenheim Mk I',
    'Defiant',
    'Spitfire I/IIA',
    'Spitfire I/IIA',
    'Spitfire I/IIA',
    'Spitfire I/IIA',
    'Spitfire I/IIA',
    'Hurricane I',
    'Hurricane I',
    'Hurricane I',
    'Hurricane I',
  ],
  13: [
    'Blenheim Mk I',
    'Hurricane I',
    'Hurricane I',
    'Hurricane I',
    'Hurricane I',
    'Hurricane I',
    'Hurricane I',
    'Spitfire I/IIA',
    'Spitfire I/IIA',
    'Spitfire I/IIA',
    'Spitfire I/IIA',
  ],
};
export default Aircrafts;
